import { useState } from 'react';

const Trash = ({ width, height, color = '#000000' }) => {
	const [isHovering, setIsHovering] = useState(false);

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width={width}
			zoomAndPan="magnify"
			viewBox="0 0 750 749.999995"
			height={height}
			preserveAspectRatio="xMidYMid meet"
			version="1.0"
			className={`border border-primary rounded-full transition duration-300 hover:bg-primary`}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			<defs>
				<clipPath id="5e31535425">
					<path d="M 227 231.25 L 513 231.25 L 513 315 L 227 315 Z M 227 231.25 " clipRule="nonzero" />
				</clipPath>
			</defs>
			<path
				strokeLinecap="round"
				transform="matrix(12.49983, 0, 0, 12.48913, 225.002027, 231.250014)"
				fill="none"
				strokeLinejoin="round"
				d="M 19.705419 10.265175 L 19.705419 21.15183 C 19.705419 21.535601 19.394165 21.846497 19.010409 21.846497 L 4.186145 21.846497 C 3.80239 21.846497 3.491135 21.535601 3.491135 21.15183 L 3.491135 10.265175 "
				stroke={isHovering ? 'white' : color}
				strokeWidth="2"
				strokeOpacity="1"
				strokeMiterlimit="4"
			/>
			<path
				strokeLinecap="round"
				transform="matrix(12.49983, 0, 0, 12.48913, 225.002027, 231.250014)"
				fill="none"
				strokeLinejoin="round"
				d="M 9.281839 17.214031 L 9.281839 10.265175 "
				stroke={isHovering ? 'white' : color}
				strokeWidth="2"
				strokeOpacity="1"
				strokeMiterlimit="4"
			/>
			<path
				strokeLinecap="round"
				transform="matrix(12.49983, 0, 0, 12.48913, 225.002027, 231.250014)"
				fill="none"
				strokeLinejoin="round"
				d="M 13.914715 17.214031 L 13.914715 10.265175 "
				stroke={isHovering ? 'white' : color}
				strokeWidth="2"
				strokeOpacity="1"
				strokeMiterlimit="4"
			/>
			<g clipPath="url(#5e31535425)">
				<path
					strokeLinecap="round"
					transform="matrix(12.49983, 0, 0, 12.48913, 225.002027, 231.250014)"
					fill="none"
					strokeLinejoin="round"
					d="M 22.0217 5.63271 L 16.230997 5.63271 M 16.230997 5.63271 L 16.230997 1.69491 C 16.230997 1.311139 15.920055 0.999931 15.535987 0.999931 L 7.660567 0.999931 C 7.276812 0.999931 6.96587 1.311139 6.96587 1.69491 L 6.96587 5.63271 M 16.230997 5.63271 L 6.96587 5.63271 M 1.175166 5.63271 L 6.96587 5.63271 "
					stroke={isHovering ? 'white' : color}
					strokeWidth="2"
					strokeOpacity="1"
					strokeMiterlimit="4"
				/>
			</g>
		</svg>
	);
};

export default Trash;
